const common = {
  app: {
    name: "Qubiq",
  },
  auth: {
    signIn: "Accedi",
    signUp: "Registrati",
    signInShort: "Accesso",
    signUpShort: "Registrazione",
  },
  landing: {
    firstMessageBefore: "Scopri ",
    firstMessageHighlight: "dove sono stati i tuoi amici",
    firstMessageAfter: " oggi.",
    secondMessageBefore: "Gioca con i tuoi amici nel ",
    secondMessageHighlight: "mondo reale.",
  },
  search: {
    placeholder: "Trova quello che vuoi...",
    ariaLabel: "Cerca",
  },
  feed: {
    untitled: "Senza titolo",
    channelFallback: "Canale",
    todayMomentsSubtitle: "Scopri dove i tuoi amici trascorrono i loro momenti migliori",
    todayMomentsLabel: "Il Tuo Momento",
    friendSpotsSection: "Gli spot dei tuoi amici",
    spotDistancePrefix: "A",
    loadMoreSpots: "Vedi altro",
    nearbyExploreTitle: "Esplora vicino a te",
    nearbyTreasureHuntsTitle: "Quest IRL",
    treasureHuntLabel: "Quest IRL",
    treasureHuntUnlockOnSite: "Quest IRL da sbloccare sul posto",
    unlockOnSite: "Da sbloccare sul posto",
    distanceAway: "A {{distance}}",
    mapFoundContent: "Contenuto trovato",
    mapNoExploreFound: "Nessun Explore trovato",
    openAction: "Apri",
    startAction: "Avvia",
    trendingNow: "Sono in hype in questo momento",
    categoriesTitle: "Categorie",
  },
  video: {
    gameAvailable: "Gioco disponibile su questo video",
    clickToPlay: "Clicca per giocare",
    tapToPlay: "Tocca per giocare",
    home: "Home",
    signInToLike: "Accedi per mettere like",
    signInToComment: "Accedi per commentare",
    exploreOnlyFromMap: "Gli Explores si aprono solo dalla mappa o dalla loro sezione dedicata.",
    enableLocationForExplore: "Attiva la tua posizione per vedere questo contenuto Explore.",
    noAnswer: "Nessuna risposta",
    youtubeLikesUnavailable: "I like non sono disponibili sui video di YouTube",
    addComment: "Aggiungi un commento...",
  },
  gameTypes: {
    quizShort: "Quiz",
    shortAnswerShort: "Risposta breve",
  },
  badges: {
    wood: "Legno",
    bronze: "Bronzo",
    silver: "Argento",
    gold: "Oro",
    uranium: "Uranio",
  },
  notifications: {
    title: "Notifiche",
    loading: "Caricamento notifiche...",
    empty: "Nessuna notifica per il momento.",
    signInRequired: "Accedi per vedere le tue notifiche.",
    loadError: "Impossibile caricare le notifiche.",
    userFallback: "Utente",
  },
  searchFeed: {
    all: "Tutto",
    spots: "Spot",
    videos: "Video",
    explores: "Explores",
    treasureHunts: "Quest IRL",
    resultsFor: "Risultati per:",
    noResults: "Nessun risultato trovato.",
    availableAt: "Disponibile a {{distance}}",
    unlockOnSite: "Da sbloccare sul posto",
    channels: "Canali",
  },
  map: {
    filters: {
      subscriptions: "Abbonamenti",
      private: "Privati",
      all: "Tutto",
    },
    myPosition: "La mia posizione",
    searchPlacePlaceholder: "Cerca Parigi, Montmartre...",
    geolocationUnavailable: "La geolocalizzazione non è disponibile su questo dispositivo.",
    enableLocationNearby: "Autorizza la geolocalizzazione per sbloccare contenuti nelle vicinanze.",
    currentPositionUnavailable: "Impossibile recuperare la tua posizione attuale.",
    googleMapsLoadError: "Google Maps non ha potuto essere caricato.",
    loadExploreSubscriptionsError: "Impossibile caricare gli abbonamenti Explore.",
    loadExplorePointsError: "Impossibile caricare i punti Explore.",
    loadExploreMapError: "Impossibile caricare la mappa Explore.",
    loadPointDetailError: "Impossibile caricare il dettaglio del punto.",
    loadTreasureHuntError: "Impossibile caricare questa quest IRL.",
    noPlaceFound: "Nessun luogo trovato per questa ricerca.",
    placeNotFound: "Luogo non trovato.",
    enableCurrentPositionBeforeSaving: "Attiva la tua posizione attuale prima di salvare un punto.",
    savePositionError: "Impossibile salvare questa posizione.",
    positionUsableForContent: "La posizione può essere usata per i contenuti",
    positionSaveFailed: "Impossibile salvare la posizione.",
    stopTreasureHuntError: "Impossibile fermare questa quest IRL.",
    gpsPointLabelPlaceholder: "Etichetta del punto GPS",
  },
  explore: {
    signInToInteract: "Accedi per interagire con questo explore.",
    likeError: "Impossibile mettere like a questo explore.",
    addCommentError: "Impossibile aggiungere il commento.",
    addReplyError: "Impossibile aggiungere la risposta.",
    likeCommentError: "Impossibile mettere like a questo commento.",
    requestSent: "Richiesta inviata",
  },
  profileMenu: {
    title: "Profilo Qubiq",
    signedOutDescription:
      "Accedi per vedere il tuo profilo, le tue notifiche e le funzioni giocatore e creator di Qubiq.",
    myProfile: "Il mio profilo",
    editProfile: "Modifica il mio profilo",
    notifications: "Notifiche",
    notificationsWithCount: "Notifiche ({{count}})",
    friendGroups: "Gruppi di amici",
    inviteFriends: "Invita i miei amici",
    inviteFriendsDesktop: "Invita i miei amici (+20 gettoni qubs)",
    createOnQubiq: "Crea su Qubiq",
    contactUs: "Contattaci",
    creatorWelcomeTitle: "Ora sei un creator di Qubiq 💛",
    creatorWelcomeDesktop:
      "Fai clic sul pulsante Qubiq Studio per caricare i tuoi video e Explores e configurare i tuoi giochi e le tue quest.",
    creatorWelcomeMobile:
      "Tocca il pulsante Qubiq Studio per caricare i tuoi video e Explores e configurare i tuoi giochi e le tue quest.",
    contactCreatorMessage:
      "Scrivimi a damien@qubiq.tv. Ti risponderò il prima possibile 💛",
    legalInfo: "Informazioni legali",
    language: "Lingua",
    languageDescription: "Scegli la lingua utilizzata su Qubiq.",
    cookiesAndConsent: "Cookie e consenso",
    manageCookies: "Gestisci i miei cookie",
    openLanguageMenu: "Apri selezione lingua",
  },
  friendGroups: {
    title: "Gruppi di amici",
    subtitle: "Crea un gruppo e invita altri giocatori a unirsi.",
    signInRequired: "Accedi per vedere i tuoi gruppi di amici.",
    loadError: "Impossibile caricare i gruppi di amici.",
    detailLoadError: "Impossibile caricare questo gruppo di amici.",
    create: "+ Crea un gruppo",
    createDialogTitle: "Crea un gruppo di amici",
    renameDialogTitle: "Rinomina il gruppo",
    groupNameLabel: "Nome del gruppo",
    groupNamePlaceholder: "Es. Team Paris",
    confirmCreate: "Crea gruppo",
    confirmRename: "Salva",
    createError: "Impossibile creare questo gruppo.",
    renameError: "Impossibile rinominare questo gruppo.",
    duplicateNameError: "Questo nome di gruppo esiste già.",
    myGroups: "I miei gruppi",
    backToGroups: "Torna ai gruppi",
    empty: "Non hai ancora gruppi di amici.",
    untitledGroup: "Gruppo senza nome",
    groupCounts: "{{count}} amici · {{pending}} richiesta/e inviata/e",
    incomingInvitesTitle: "Inviti ricevuti",
    invitedBy: "Invitato da {{username}}",
    accept: "Conferma",
    refuse: "Annulla",
    refuseInviteAction: "Rifiuta",
    acceptInviteError: "Impossibile accettare questo invito.",
    refuseInviteError: "Impossibile rifiutare questo invito.",
    selectGroup: "Scegli un gruppo",
    selectGroupDescription: "Seleziona un gruppo a sinistra per vedere gli amici e inviare nuovi inviti.",
    searchUsersTitle: "Aggiungi amici",
    searchPlayersPlaceholder: "Cerca giocatori",
    searchResults: "Risultati",
    searching: "Ricerca in corso...",
    noSearchResults: "Nessun utente trovato.",
    membersTitle: "Membri del gruppo",
    noMembersYet: "Ancora nessun membro.",
    addUserDialogTitle: "Aggiungere al mio gruppo di amici?",
    addUserDialogBody: "Vuoi inviare un invito a {{username}}?",
    confirm: "Conferma",
    cancel: "Annulla",
    inviteError: "Impossibile inviare questo invito.",
    friendStatus: "Amico/a",
    meLabel: "Io",
    requestSentStatus: "Richiesta inviata",
    incomingInviteDialogTitle: "Entrare in questo gruppo di amici?",
    incomingInviteDialogBody: "Vuoi entrare nel gruppo {{groupName}}?",
    leaveGroup: "Lascia il gruppo",
    leaveDialogTitle: "Lascia il gruppo",
    leaveDialogBody: "Potrai sempre tornare più tardi se qualcuno ti inviterà di nuovo.",
  },
  inviteFriends: {
    pageTitle: "Invita i tuoi amici",
    popupTitle: "Invita i tuoi amici su Qubiq",
    popupBodyBeforeReward: "Tu e il tuo amico guadagnate",
    popupBodyAfterReward: "quando si iscrive con il tuo link.",
    messageLabel: "Messaggio",
    copyIconLabel: "Copia",
    rewardLine: "20 qubs per il tuo amico e 20 qubs per te",
    helper:
      "Scegli i contatti se il tuo dispositivo lo consente. Altrimenti Qubiq apre la condivisione del dispositivo o copia il messaggio.",
    cta: "Invita i miei amici",
    copyButton: "Copia il messaggio",
    copied: "Messaggio copiato",
    loadError: "Impossibile preparare il tuo link di invito.",
    actionError: "Impossibile aprire l'invito.",
  },
  cookieConsent: {
    bannerTitle: "Qubiq utilizza i cookie",
    bannerDescription:
      "Utilizziamo tracciatori necessari al funzionamento del servizio e, con il tuo consenso, cookie di misurazione dell’audience per capire meglio l’uso di Qubiq.",
    bannerDetails:
      "Puoi accettare, rifiutare o personalizzare le tue scelte. Rifiutare è semplice quanto accettare e potrai modificare le tue preferenze in seguito.",
    customize: "Personalizza",
    refuseAll: "Rifiuta tutto",
    acceptAll: "Accetta tutto",
    preferencesTitle: "Gestisci i miei cookie",
    preferencesDescription:
      "Scegli quali tracciatori possono essere utilizzati su Qubiq. I cookie necessari restano attivi per consentire accesso, sicurezza e funzioni essenziali del servizio.",
    analyticsNotice:
      "Google Analytics resta disattivato finché non accetti la misurazione dell’audience.",
    necessaryTitle: "Cookie necessari",
    necessaryDescription:
      "Accesso, sicurezza, stabilità della sessione e funzioni tecniche indispensabili.",
    analyticsTitle: "Misurazione dell’audience",
    analyticsDescription:
      "Google Analytics 4 per misurare traffico, prestazioni e utilizzo complessivo di Qubiq.",
    marketingTitle: "Marketing",
    marketingDescription:
      "Categoria riservata a futuri usi marketing. Per il momento resta disattivata.",
    cancel: "Annulla",
    saveChoices: "Salva le mie scelte",
  },
  navigation: {
    profile: "Profilo",
    home: "Home",
    infoAndRules: "Info e regole",
    creatorsShow: "I nostri creator fanno spettacolo",
    explore: "Explore",
    rankings: "Classifiche",
  },
  sidebar: {
    hangout: "Dove passa il tempo tutta la community",
    welcomeCommunity: "Benvenuto nella community",
  },
  categories: {
    entertainment: "Intrattenimento",
    quiz: "Quiz e ripasso",
    science: "Divulgazione scientifica",
    sport: "Sport",
    esport: "Esport",
    music: "Musica",
  },
  visibility: {
    public: "Pubblica",
    notListed: "Non in elenco",
    private: "Privata",
  },
  ranking: {
    rankingGeneral: "Classifica generale",
    progression: "Progressione",
    rankings: "Classifiche",
    exploreRankings: "Classifiche Explore",
    players: "Giocatori",
    channels: "Canali",
    loading: "Caricamento classifica...",
    irlQuest: "Quest IRL",
    overall: "Generale",
    rules: {
      useCase: "Caso d'uso",
      reward: "Ricompensa",
      info: "Info",
      quizVictoryLabel: "Vittoria Quiz",
      quizVictoryInfo: "Data una sola volta per gioco.",
      questionAnswerVictoryLabel: "Vittoria Domanda Risposta",
      questionAnswerVictoryInfo: "Data una sola volta per gioco.",
      defeatLabel: "Sconfitta",
      defeatInfo: "Se timeout: 0 XP",
      questCompletedLabel: "Quest completata",
      questCompletedInfo: "Data a ogni completamento della quest",
      creatorGamePlayLabel: "Gioco giocato sui tuoi contenuti",
      creatorGamePlayInfo: "Dato una sola volta per tripletta creatore, gioco e giocatore, vittoria o sconfitta",
      exploreLikeReceivedLabel: "Like sul tuo explore",
      exploreLikeReceivedInfo: "Dato una sola volta per utente e per explore",
      exploreViewReceivedLabel: "Visualizzazione del tuo explore",
      exploreViewReceivedInfo: "Dato per ogni nuova sessione qualificata",
    },
  },
  profile: {
    notFound: "Profilo non trovato.",
    loadError: "Impossibile caricare questo profilo.",
    signInToSubscribe: "Accedi per iscriverti.",
    subscribeFailed: "L'iscrizione non è riuscita.",
    deletePostFailed: "Impossibile eliminare questo post.",
    likePostFailed: "Impossibile mettere like a questo post.",
    updateQubsVisibilityFailed: "Impossibile aggiornare la visibilità dei qubs.",
    videos: "Video",
    explores: "Explores",
    treasureHunts: "Quest IRL",
    history: "Cronologia",
    wallet: "Wallet",
    noVideosWatched: "Nessun video guardato per ora.",
    viewedDuration: "Visto {{duration}}",
  },
  bannerCounter: {
    loadError: "Impossibile caricare il wallet.",
    offline: "offline",
  },
  studio: {
    explorePublicGpsRequired: "Collega questo Explore a una posizione GPS prima di renderlo pubblico.",
    explorePrivateGpsRequired: "Collega questo Explore a una posizione GPS prima di concedere accessi privati.",
    title: "Qubiq Studio",
    createAction: "Crea",
    viewChannel: "Vedi il mio profilo",
    subtitle: "Gestisci il tuo canale, carica i tuoi video e configura i tuoi giochi",
    loading: "Caricamento...",
    signInRequired: "Accedi per entrare in Studio.",
    channel: "Canale",
    profile: "Modifica il mio profilo",
    questsAndExplores: "Quest ed Explores",
    videos: "Video",
    explores: "Explores",
    exploresDescription:
      "Gli Explores sono video brevi che puoi collocare in luoghi precisi.\n\nRegistra la posizione GPS di un posto che scopri, poi nascondici un Explore o una tappa di una Quest IRL.",
    treasureHunts: "Quest IRL",
    myChannel: "Il mio canale",
    archives: "Archivi",
    statusUploading: "Upload in corso",
    statusProcessing: "Elaborazione",
    statusReady: "Pronta",
    statusError: "Errore",
    gpsPosition: "Posizione GPS",
    manageGpsPoints: "Gestisci i miei punti GPS",
    manageGpsPointsDescription: "Trova, rinomina ed elimina le posizioni GPS salvate per i tuoi Explore.",
    backToExplores: "Torna agli Explore",
    gpsPointSearchPlaceholder: "Cerca un punto GPS per nome",
    gpsPointLabel: "Nome del punto GPS",
    unnamedGpsPoint: "Punto GPS senza nome",
    noGpsPoints: "Nessun punto GPS salvato per ora.",
    noGpsPointSearch: "Nessun punto GPS corrisponde a questa ricerca.",
    gpsPointInUse: "Usato da {{count}} Explore(s)",
    gpsPointUnused: "Questo punto non è usato da alcun Explore.",
    deleteGpsPoint: "Elimina punto",
    gpsPointDeleteQuestion: "Eliminare definitivamente \"{{label}}\"?",
    gpsPointDeleteBlocked: "Questo punto è usato da {{count}} Explore(s). Rimuovilo da questi Explore prima di eliminarlo.",
    loadMoreGpsPoints: "Mostra altri punti",
    gpsPointsCount: "{{count}} punto/i GPS",
    gpsMapUnavailable: "L'anteprima di Maps non è disponibile. Le coordinate restano visibili qui sopra.",
    laptop: "Laptop",
    tablet: "Tablet",
    smartphone: "Smartphone",
    durationCheckError: "Impossibile verificare la durata di questo video.",
    uploadFinishedProcessing: "Upload completato. Elaborazione qualità e codifica in corso.",
    verticalPreviewInfo: "Per gli Explores viene mostrata una sola anteprima verticale.",
    saving: "Salvataggio...",
    save: "Salva",
    saveGame: "Salva il gioco",
    cancel: "Annulla",
    edit: "Modifica",
    editPhoto: "Modifica foto",
    savingProfile: "Salvataggio...",
    saveProfile: "Salva profilo",
    noGamesConfigured: "Nessun gioco configurato.",
    noArchivedExplore: "Nessun Explore archiviato per ora.",
    noArchivedVideo: "Nessun video archiviato per ora.",
    noArchivedExploreSearch: "Nessun Explore archiviato corrisponde a questa ricerca.",
    noArchivedVideoSearch: "Nessun video archiviato corrisponde a questa ricerca.",
    loadingVideos: "Caricamento video...",
    noExploreYet: "Nessun Explore per ora.",
    noVideoYet: "Nessun video per ora.",
    noExploreSearch: "Nessun Explore corrisponde a questa ricerca.",
    noVideoSearch: "Nessun video corrisponde a questa ricerca.",
    noDescription: "Nessuna descrizione.",
    untitled: "Senza titolo",
    confirm: "Conferma",
    loadingAccess: "Caricamento accessi...",
    noLinkedAccount: "Nessun account collegato per ora",
    close: "Chiudi",
    quizFirstTwoAnswersRequired: "Le prime due risposte sono obbligatorie per {{game}}.",
    chooseCorrectAnswer: "Scegli la risposta corretta.",
    correctAnswerMustBeFilled: "La risposta corretta deve puntare a una risposta compilata.",
    shortAnswerRequired: "La risposta corretta è obbligatoria per {{game}}.",
    configureChannel: "Configura il mio canale",
    profilePhotoAlt: "Foto profilo",
    firstName: "Nome",
    lastName: "Cognome",
    username: "Nome utente",
    bio: "Bio",
    channelName: "Nome del tuo canale",
    channelNameHelper: "Obbligatorio per caricare un video.",
    channelDescription: "Descrizione del tuo canale",
    statusLabel: "Stato",
    draftStatus: "Bozza",
    publishedStatus: "Pubblicata",
    authorizedEmailsLabel: "Email autorizzate",
    authorizedEmailsHelper: "Una email per riga o separate da virgole.",
    titleLabel: "Titolo",
    categoryLabel: "Categoria",
    visibilityLabel: "Visibilità",
    descriptionLabel: "Descrizione",
    archivedVideosTab: "Video",
    archivedExploresTab: "Explores",
    archivedVideoSearchPlaceholder: "Cerca un video archiviato per titolo",
    archivedExploreSearchPlaceholder: "Cerca un Explore archiviato per titolo",
    videoSearchPlaceholder: "Cerca un video per titolo",
    exploreSearchPlaceholder: "Cerca un Explore per titolo",
    removeFromArchives: "Rimuovi dagli archivi",
    addVideo: "Aggiungi un video",
    addExplore: "Aggiungi un Explore",
    refresh: "Aggiorna",
    archive: "Archivia",
    changeThumbnail: "Cambia miniatura",
    uploadThumbnail: "Caricamento miniatura...",
    managePrivateAccess: "Gestisci accessi privati",
    authorizedEmailsCount: "{{count}} email autorizzata/e",
    addEmails: "Aggiungi una o più email",
    add: "Aggiungi",
    validate: "Convalida",
    viewVideo: "Vedi video",
    dateLabel: "Data",
    viewsLabel: "Visualizzazioni",
    configureGame: "Configura {{game}}",
    editGame: "Modifica {{game}}",
    gameMoment: "Momento",
    gameStartTimecode: "Timecode di inizio",
    gameEndTimecode: "Timecode di fine",
    timeFormatHelper: "Usa 00:00 o 00:00:00.",
    gameStartsAt: "Il gioco inizia in questo momento.",
    gameEndsAt: "Il gioco termina in questo momento.",
    answerTime: "Tempo per rispondere",
    secondsToAnswer: "secondi per rispondere",
    timecodeReference: "Riferimento del timecode",
    gameStartReference: "Timecode di inizio del gioco",
    gameEndReference: "Timecode di fine del gioco",
    question: "Domanda",
    answerOne: "Risposta 1",
    answerTwo: "Risposta 2",
    answerThree: "Risposta 3",
    answerFour: "Risposta 4",
    correctAnswer: "Risposta corretta",
    expectedAnswer: "Risposta attesa",
    expectedAnswerHelper: "La risposta del giocatore verrà normalizzata prima del confronto.",
    successMessage: "Messaggio di successo",
    failureMessage: "Messaggio di errore",
    globalPauseModeActive:
      "Configurazione globale attiva: la modalità pausa è definita a livello del video",
    pauseVideoDuringGame: "Video in pausa durante il gioco",
    hardcoreAnswersGlobal:
      "Modalità hardcore attiva: le risposte multiple sono definite globalmente",
    allowMultipleAnswers: "Consenti risposte multiple",
    hardcoreRegainGlobal:
      "Modalità hardcore attiva: il recupero è definito globalmente",
    enableMultipleAnswersFirst:
      "Attiva prima le risposte multiple per consentire il recupero",
    allowRegainEachVictory: "Consenti recupero a ogni vittoria",
    globalGameConfig: "Configurazione globale per i giochi di questo video",
    hardcoreWholeVideo: "Modalità hardcore su tutto il video",
    pauseAllGames: "Video in pausa per tutti i giochi di questo video",
    pauseCannotDisable: "La pausa del video non può essere disattivata al momento.",
    overlappingGamesWithoutPause: "Questi giochi si sovrapporrebbero senza pausa:",
    allowMultipleAnswersAllHardcore:
      "Consenti risposte multiple in tutti i giochi hardcore",
    allowRegainAllHardcore: "Consenti recupero in tutti i giochi hardcore",
    hardcoreGlobalAllocation:
      "La modalità hardcore forza l'allocazione globale. Replay e recupero si configurano sopra.",
    applyToAllGames: "Applica a tutti i giochi",
    addGame: "Aggiungi un gioco",
    removeGameError: "Impossibile eliminare il gioco.",
    removeGameFailed: "Il gioco non può essere eliminato.",
    gameDisabled: "Gioco disattivato.",
    disableGame: "Disattiva",
    irlQuestCardLabel: "Quest IRL",
    newTreasureHunt: "Nuova Quest IRL",
    treasureHuntsLoadError: "Impossibile caricare le Quest IRL.",
    treasureHuntCreated: "Quest IRL creata.",
    treasureHuntSaved: "Quest IRL salvata.",
    treasureHuntDeleted: "Quest IRL eliminata.",
    availableExploresLoadError: "Impossibile caricare gli Explores disponibili.",
    exploresAddedToQuest: "Explores aggiunti alla Quest IRL.",
    reorderExploresError: "Impossibile riordinare gli Explores.",
    exploreRemovedFromQuest:
      "Explore rimosso dalla Quest IRL. Tornerà visibile sulla mappa normale se è pubblico.",
    removeExploreFromQuestError: "Impossibile rimuovere questo Explore.",
    treasureHuntThumbnailUpdated: "Miniatura della Quest aggiornata.",
    configureTreasureHunt: "Seleziona una Quest IRL da configurare.",
    treasureHuntName: "Nome della Quest",
    addExistingExplores: "Aggiungi Explores esistenti",
    noExploreInTreasureHunt: "Nessun Explore in questa Quest IRL per il momento.",
    noCategory: "Senza categoria",
    moveUp: "Sposta su",
    moveDown: "Sposta giù",
    remove: "Rimuovi",
    savingTreasureHunt: "Salvataggio...",
    saveTreasureHunt: "Salva la Quest",
    delete: "Elimina",
    treasureHuntsDescription:
      "Le Quest IRL sono percorsi di Explores da completare passo dopo passo.\n\nI giocatori devono trovare ogni luogo e superare i giochi in ogni Explore per sbloccare tutte le tappe.",
    createNewExplore: "Crea un nuovo Explore",
    createTreasureHunt: "Crea una Quest IRL",
    searchTreasureHunt: "Cerca una Quest per titolo",
    treasureHuntCount: "{{count}} explore(s)",
    noTreasureHuntYet: "Nessuna Quest IRL per il momento.",
    noTreasureHuntSearch: "Nessuna Quest IRL corrisponde a questa ricerca.",
    signInToStartTreasureHunt: "Accedi per avviare la quest.",
    replayable: "Rigiocabile",
    oneAttempt: "Un tentativo",
    addExistingExploresTitle: "Aggiungi Explores esistenti",
    outsideMapWarning:
      "Gli Explores già collegati a un'altra Quest IRL verranno rimossi dalla loro Quest attuale.",
    loadingAvailableExplores: "Caricamento Explores disponibili...",
    noAvailableExplore: "Nessun Explore disponibile da aggiungere.",
    deleteTreasureHuntTitle: "Elimina la Quest",
    deleteTreasureHuntDescription:
      "Questa azione elimina definitivamente la Quest IRL senza eliminare gli Explores associati.",
    deleting: "Eliminazione...",
  },
  languageDialog: {
    title: "Lingua",
    description:
      "Scegli la lingua utilizzata su Qubiq. Se la lingua del browser non è supportata, l'app utilizza automaticamente l'inglese.",
    close: "Chiudi",
  },
  legalLinks: {
    terms: "Condizioni",
    legal: "Note legali",
    privacy: "Privacy",
    cookies: "Cookie",
    moderation: "Moderazione",
  },
  languages: {
    fr: "Français",
    en: "English",
    es: "Español",
    de: "Deutsch",
    pt: "Português",
    it: "Italiano",
  },
};

export default common;
